<div id="hotel-result-component" class="d-flex" style="border: 1px solid #e0e0e0;  border-radius: 7px 7px 7px 7px; background-color: white; width: auto;" *ngIf="!mapView">


    <div class="d-flex flex-xl-column flex-column container-img "  style="align-items: flex-start; ">

      <!-- <div
          class="flex-xl-grow-0 flex-grow-1 w-100"
       [style.width.xl]="'100%'"
       [style.maxWidth.xl]="'235px'">



        <img

              style="width: 100%; height: auto; aspect-ratio: 1.2/1; cursor: pointer; object-fit: cover"
             (click)="openModal(ModalRooms, 'photos');"
             [src]="result.portrait">
      </div> -->

      <div class="d-flex justify-content-end align-items-center w-100 px-2 position-relative" style="height: 75px">
        <img class="img-logo " style="position: absolute; left: 8%" *ngIf="result?.logo "  src="{{result?.logo}}" alt="logo">

        <div class="d-flex justify-content-end align-items-center"
            style="height: 100%;"
            [ngStyle]="{'margin-bottom': result?.additionalInfo?.rooms[0]?.room?.rateClass == 'R' ? '-3px' : '7px'}">

          <div class="d-flex align-items-middle" style="height: 28px;">
            <img src="../../../../../assets/img/app/little-icons/badge-bks.png" alt="" style="margin-right: 5px;">
            <span class="font-point d-flex align-items-center">
              {{ result?.price?.blickoins | number:'1.2-2' }}&nbsp;Bks
            </span>
          </div>
        </div>
      </div>
    </div>


  <!-- Columna central - Detalles del vuelo -->
  <div class="d-flex flex-column container-detalles pb-3 px-3 pt-2">

    <!-- Iconos de acciones (comentarios, videos, etc) -->
    <!-- <div class="d-flex justify-content-start mb-4">
      <button type="button" class="px-0" style="border:none;background-color: transparent;">
        <img width="20px" height="20px" src="../../../../../assets/icons/search-result/comentario.svg"
              (click)="openModal(ModalFlight, 'details');"
              tooltip="Detalles del vuelo"
              placement="bottom"
              alt="">
      </button>
      <div class="d-flex content-icons mt-1 px-1">
        <div class="d-flex font-view px-3" style="border-left: 1px solid #bbbbbb;border-right: 1px solid #bbbbbb;">
          <img width="20px" height="20px" src="../../../../../assets/icons/search-result/view.svg" class="m-0 mr-1">
          <p class="d-flex mb-0 flex-column justify-content-center" style="font-family: 'Rubik'; text-transform: lowercase;">
            <span style="line-height: .5;">{{ view_flight || 0 }}</span>
            <span style="line-height: 1.07;">views</span>
          </p>
        </div>
      </div>
    </div> -->

    <!-- Título de la aerolínea y información general -->
    <div class="d-flex justify-content-between">
      <div class="d-flex flex-column" style="overflow: hidden">
        <p class="title" style="margin-bottom: 4px;">
          {{ result?.itinerary[0]?.options[0]?.segments[0]?.airline?.name ||
             result?.itinerary[0]?.options[0]?.segments[0]?.airline?.code ||
             result?.fare?.validatingCarrier || 'Aerolínea' }}
        </p>
        <p class="location m-0" style="color: #bbbbbb">
          {{ result?.fare?.brandName || 'Económica' }} • {{ result?.fare?.validatingCarrier }} •
          Tiempo emisión: {{ result?.fare?.lastTicketingDate | date:'dd/MM/yyyy' }}
        </p>
      </div>
    </div>

    <!-- Información de origen y destino (resumen) -->
    <div class="d-flex mb-4" style="margin-top: 10px;">
      <div class="d-flex flex-column w-100">
        <!-- Origen -->
        <div class="d-flex align-items-center mb-2">
          <div class="d-flex flex-column mr-3" style="min-width: 70px;">
            <span class="font-weight-bold" style="font-size: 16px;">
              {{ result?.itinerary[0]?.options[0]?.segments[0]?.departure?.time | slice:0:5 }}
            </span>
            <span style="font-size: 12px; color: #666;">
              {{ result?.itinerary[0]?.options[0]?.segments[0]?.departure?.airport }}
            </span>
          </div>
          <div class="d-flex flex-column flex-grow-1 mx-2">
            <div class="d-flex align-items-center">
              <span class="text-muted" style="font-size: 12px;">Salida</span>
            </div>
            <div class="d-flex align-items-center">
              <div class="border-top border-secondary flex-grow-1" style="border-width: 2px !important;"></div>
              <i class="bi bi-airplane-fill mx-2" style="color: #00d398; font-size: 14px;"></i>
              <div class="border-top border-secondary flex-grow-1" style="border-width: 2px !important;"></div>
            </div>
            <div class="d-flex justify-content-between">
              <span style="font-size: 11px; color: #999;">{{ result?.itinerary[0]?.options[0]?.segments[0]?.flight?.number }}</span>
              <!-- <span style="font-size: 11px; color: #999;">{{ result?.itinerary[0]?.options[0]?.duration | flightDuration }}</span> -->
            </div>
          </div>
          <!-- Destino -->
          <div class="d-flex flex-column ml-3" style="min-width: 70px; text-align: right;">
            <span class="font-weight-bold" style="font-size: 16px;">
              {{ result?.itinerary[0]?.options[0]?.segments[result?.itinerary[0]?.options[0]?.segments.length - 1]?.arrival?.time | slice:0:5 }}
            </span>
            <span style="font-size: 12px; color: #666;">
              {{ result?.itinerary[0]?.options[0]?.segments[result?.itinerary[0]?.options[0]?.segments.length - 1]?.arrival?.airport }}
            </span>
          </div>
        </div>

        <!-- Si hay escalas, mostrar indicador -->
        <div *ngIf="result?.itinerary[0]?.options[0]?.segments.length > 1" class="d-flex justify-content-center mt-1">
          <span class="badge badge-pill" style="background-color: #f0f0f0; color: #666; font-size: 11px; padding: 4px 10px;">
            {{ result?.itinerary[0]?.options[0]?.segments.length - 1 }}
            {{ (result?.itinerary[0]?.options[0]?.segments.length - 1) === 1 ? 'escala' : 'escalas' }}
            ({{ result?.itinerary[0]?.options[0]?.segments[0]?.departure?.airport }}
            → {{ result?.itinerary[0]?.options[0]?.segments[1]?.departure?.airport }} ...)
          </span>
        </div>

        <!-- Si es directo -->
        <div *ngIf="result?.itinerary[0]?.options[0]?.segments.length === 1" class="d-flex justify-content-center mt-1">
          <span class="badge badge-pill" style="background-color: #e6f7e6; color: #00a651; font-size: 11px; padding: 4px 10px;">
            Vuelo directo
          </span>
        </div>
      </div>
    </div>

    <!-- Información de la clase y equipaje -->
    <div class="d-flex mt-2">
      <div class="description pt-1 d-flex flex-column w-100">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <span style="font-size: 13px; font-weight: 500;">Clase: </span>
            <span style="font-size: 13px;">{{ result?.itinerary[0]?.options[0]?.segments[0]?.cabin?.brandName ||
                                                result?.itinerary[0]?.options[0]?.segments[0]?.cabin?.class ||
                                                result?.fare?.brandName || 'Económica' }}</span>
          </div>
          <div>
            <span style="font-size: 13px; font-weight: 500;">Equipaje: </span>
            <span style="font-size: 13px;">
              {{ result?.itinerary[0]?.options[0]?.segments[0]?.baggage?.checked || 'No incluido' }}
              <span *ngIf="result?.itinerary[0]?.options[0]?.segments[0]?.baggage?.carryOn"> + Cabina</span>
            </span>
          </div>
        </div>
        <p class="mt-2" style="font-size: 12px; color: #666;" (click)="openModalDetail(result);" style="cursor: pointer;">
          Ver detalles del vuelo <i class="bi bi-chevron-right" style="font-size: 10px;"></i>
        </p>
      </div>
    </div>
  </div>

  <!-- Columna derecha - Precio y botón de acción -->
  <div class="d-flex flex-column container-price"
       [ngStyle]="{
         'background-color': stylePathPrice?.card_background_price,
         'border-color': stylePathPrice?.card_line }">

    <div class="d-flex flex-column px-3 mt-4 mb-3" style="margin-left: 9px; position: relative;">

      <!-- Etiqueta de promoción (si existe) -->
      <span *ngIf="result?.price?.originalTotal && result.price.total < result.price.originalTotal">
        <div class="d-flex flex-column justify-content-center align-items-center"
             style="background-color: #ed3b5b; border-radius: 50rem; border-bottom-right-radius: 50% 40%; width: 60px; height: 50px;">
          <p class="mb-0" style="font-family: 'Rubik', serif; font-size: 9px; font-weight: 600; color: white; line-height: 1;">Ahorrás</p>
          <p class="mb-0" style="font-family: 'Rubik', serif; font-size: 9px; font-weight: 600; color: white; line-height: 1;">
            {{ currencyAgency?.code }} {{ (result.price.originalTotal - result.price.total) | currencyConverterPure:
                      result.price.currency :
                      currencyAgency?.code:
                      currencies
                    | number: '1.2-2' }}
          </p>
        </div>
      </span>

      <!-- Precio desde -->
      <div>
        <p class="fromPrice" style="margin-bottom: 0px; margin-top: 15px; height: 18px;">Desde</p>
      </div>

      <!-- Precio principal -->
      <div *ngIf="result?.passengers && result.passengers.length > 0">
        <p class="currencyResult">{{ currencyAgency?.code || result?.price?.currency || 'USD' }}</p>
      </div>

      <div class="d-flex">
        <p style="height: auto;"
           class="mb-0 converted-currency"
           [ngClass]="{'priceMoney': (result?.price?.total | number).length <= 4, 'count-dot-value': (result?.price?.total | number).length > 4}"
           [ngStyle]="{
             'font-size': (result?.price?.total |  currencyConverterPure:
                     result.price.currency:
                      currencyAgency?.code:
                      currencies
                    | dynamicFontSize: 29 : fontSizeAdjustments)
           }">
          {{ (result?.passengers[0]?.price?.total || result?.price?.total) | currencyConverterPure:
                      result.price.currency:
                      currencyAgency?.code:
                      currencies
                    | number: '1.2-2' }}
        </p>
        <usb-tooltip-convert-amount
          [clientsSettingAppBooking]="clientsSettingAppBooking"
          [currencyProduct]="result?.price?.currency || 'USD'"
          [valueProduct]="result?.passengers[0]?.price?.total || result?.price?.total">
        </usb-tooltip-convert-amount>
      </div>

      <!-- Precio en moneda original (si es diferente) -->
      <div *ngIf="result?.price?.currency && result?.price?.currency !== currencyAgency?.code">
        <div class="d-flex">
          <p style="height: auto; font-weight: 400; font-size: 12px">
            ({{ result.price.currency }}) {{ result.passengers[0]?.price?.total || result.price.total | number:'1.2-2' }}
          </p>
          <div class="info-tool d-flex flex-column position-relative">
            <img src="../../../assets/icons/admi_01.svg" width="12px" alt="">
            <span class="tooltip-info shadow-md">
              <div class="d-flex justify-content-center align-items-center px-2 py-1">
                <p class="mb-0" style="font-size: 14px; color: black;">{{ userService?.messageProviderAmount }}</p>
              </div>
            </span>
          </div>
        </div>
      </div>

      <!-- Texto de impuestos incluidos -->
      <div>
        <p style="font-family: 'Rubik', serif; font-size: 11px; font-weight: 600; margin-bottom: 25px;">Impuestos incluidos</p>
      </div>
    </div>

    <!-- Tipo de tarifa (reembolsable / no reembolsable) y botón -->
    <div class="d-flex flex-column" style="margin-bottom: 10px">
      <div class="d-flex flex-row justify-content-center mb-1">
        <div class="d-flex flex-column align-items-center">
          <span class="description-modal-cg" aria-hidden="true" *ngIf="result?.fare?.cancelPolicy !== 'MDNT'">
            {{ getCancellationPolicy(result?.fare?.cancelPolicy) }}
          </span>
          <span class="description-modal-nr" aria-hidden="true" *ngIf="result?.fare?.cancelPolicy === 'MDNT'">
            No reembolsable
          </span>
          <span *ngIf="result?.fare?.cancelPolicy !== 'MDNT' && result?.fare?.lastTicketingDate" class="sub-decription-modal-cg">
            Hasta {{ result.fare.lastTicketingDate | date:'dd/MM/yyyy' }}
          </span>
        </div>
      </div>
      <div class="d-flex justify-content-center">
        <button type="button"
                [disabled]="!result?.price?.total || result.price.total === 0"
                class="btn btn-add"
                style="border-radius: 6px"
                [ngStyle]="{
                  'color': stylePathPrice?.color_2,
                  'background-color': clientsSettingAppBooking?.clients_setting_global?.color_main_1
                }">
          Agregar
        </button>
      </div>
    </div>
  </div>
</div>
